module.exports = __webpack_public_path__ + "img/tuse_down_code.2b5b2ebf.png";